import React from 'react';
import { Box, Grid, Typography, Chip, Stack, Paper } from '@mui/material';
import { images } from '../assets/images';
import { Section, Heading, Img } from './common';

const body = { color: 'text.secondary', lineHeight: 1.8, fontSize: '1.05rem', mb: 2 };

const About = () => (
  <Section id="about" sx={{ pt: { xs: 12, md: 16 } }}>
    <Grid container spacing={{ xs: 6, md: 10 }} alignItems="center">
      <Grid item xs={12} md={5}>
        <Box sx={{ position: 'relative', pr: 3, pb: 3 }}>
          <Box sx={{ position: 'absolute', right: 0, bottom: 0, width: '80%', height: '80%', bgcolor: 'secondary.main', borderRadius: '12px' }} />
          <Box sx={{ position: 'relative', aspectRatio: '4 / 3', borderRadius: '12px', overflow: 'hidden' }}>
            <Img src={images.about} alt="BPT students and faculty at a partner hospital" />
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={7}>
        <Heading title="A health sciences group built on nursing education" />
        <Typography sx={body}>
          Shree Bhavani Group of Institutions (SBGI) is a health sciences education group in Bangalore, managed by The St. Lords Educational Trust. The trust was established in 2003 by Dr. D. Devaiah and first focused on nursing education for students from across India. It now offers programmes in nursing, paramedical sciences and allied health.
        </Typography>
        <Typography sx={body}>
          Education here is about more than results. SBGI focuses on the mental, physical and personal growth of students, so they become competent, committed and compassionate healthcare professionals.
        </Typography>
        <Stack direction="row" flexWrap="wrap" gap={1} sx={{ mt: 3 }}>
          {['Rajiv Gandhi University of Health Sciences', 'Karnataka State Paramedical Board', 'Karnataka State Nursing Council'].map((t) => (
            <Chip key={t} label={t} color="primary" variant="outlined" />
          ))}
        </Stack>
      </Grid>
    </Grid>

    <Grid container spacing={4} sx={{ mt: { xs: 6, md: 10 } }}>
      {[
        ['About physiotherapy', 'Physiotherapists help people reduce pain, improve movement and recover from injuries, illnesses and physical conditions. They work with patients recovering from sports injuries, accidents, surgeries, strokes and age-related conditions.'],
        ['About the BPT programme', 'The BPT programme combines classroom learning with practical and clinical training. Students build skills in exercises, manual therapy and therapeutic techniques, and apply them with patients under professional supervision.'],
      ].map(([t, d]) => (
        <Grid item xs={12} md={6} key={t}>
          <Paper elevation={0} sx={{ p: 4, height: '100%', border: '1px solid', borderColor: 'divider', borderRadius: '12px' }}>
            <Typography variant="h5" sx={{ color: 'primary.dark', mb: 1.5 }}>{t}</Typography>
            <Typography sx={{ color: 'text.secondary', lineHeight: 1.8 }}>{d}</Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  </Section>
);

export default About;
